import React from 'react';
import { Navbar } from '../components/homepage/Navbar';
import { HeroSection } from '../components/homepage/HeroSection';
import { PillarsSection } from '../components/homepage/PillarsSection';
import { HowItWorks } from '../components/homepage/HowItWorks';
import { WhyBillvast } from '../components/homepage/WhyBillvast';
import { Footer } from '../components/homepage/Footer';
export const Homepage: React.FC = () => {
  return <div className="min-h-screen bg-white font-sans text-brand-text-dark selection:bg-brand-primary/20 selection:text-brand-primary-dark" data-id="element-740">
      <Navbar data-id="element-741" />
      <main data-id="element-742">
        <HeroSection data-id="element-743" />
        <PillarsSection data-id="element-744" />
        <HowItWorks data-id="element-745" />
        <WhyBillvast data-id="element-746" />
      </main>
      <Footer data-id="element-747" />
    </div>;
};